"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.validateCreateDeckBody = void 0;
const validation_1 = require("@fmtk/validation");
exports.validateCreateDeckBody = (0, validation_1.properties)({
    name: (0, validation_1.text)(),
});
//# sourceMappingURL=CreateDeckBody.js.map